/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import RequiredIndicator from '../RequiredIndicator';

const Select = ({ label, name, placeholder, options, value, setValue, register, required }) => {
  const handleChange = (e) => {
    e.preventDefault();

    setValue(e.target.value);
  };
  return (
    <div className="dropdown-container">
      <label htmlFor={name}>
        {required && <RequiredIndicator label={label} />}
        {!required && <b>{label}</b>}
      </label>
      <select
        value={value || placeholder}
        className="caption"
        ref={register}
        name={name}
        id={name}
        onChange={(e) => handleChange(e)}
      >
        <option className="item" value="" hidden>{placeholder}</option>
        {options &&
          options.map((item) => (
            <option className="item" key={item} value={item}>
              {item}
            </option>
          ))}
      </select>
    </div>
  );
};

export default Select;


